import axios from 'axios';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

import React, { useState } from 'react';

import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';
import { CheckboxGroup } from '@src/utils';

const url = `${process.env.REACT_APP_API_URL}/preferences`;

export default function AddPreferences({ openModal, setOpenModal, fetchData }) {
  const { auth } = useAuth();
  const [data, setData] = useState([]);

  const handleType = (value, isChecked) => {
    if (data) {
      const types = Array.isArray(data.role) ? data.role : [];

      const updatedSelection = isChecked
        ? [...types, value]
        : types.filter((selected) => selected !== value);

      setData({ ...data, role: updatedSelection });
    } else {
      console.error('data is not defined');
    }
  };

  React.useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        if (openModal) {
          const response = await axios.get(`${url}/${openModal}`, {
            headers: {
              Authorization: `Bearer ${auth.idToken}`,
            },
          });

          // eslint-disable-next-line prefer-destructuring
          const role = response.data.role;
          const normalizedRole = Array.isArray(role) ? role : [role];
          setData({
            ...response.data,
            role: normalizedRole,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchDataAsync();
  }, [auth.idToken, openModal]);

  const handlePost = () => {
    const formData = {
      item: data?.item,
      role: data?.role,
    };

    axios
      .post(`${url}`, formData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        console.log('Item updated successfully:', response);
        setData({ ...data });
        fetchData();
        toast.success('Item updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.log(error.message);
        toast.error(`${error.response.data.message}`, {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  };

  return (
    <Dialog
      maxWidth='lg'
      fullwidth
      open={openModal}
      onClose={() => setOpenModal(false)}
    >
      <DialogTitle>Add new preferences</DialogTitle>
      <br />

      <DialogContent>
        <Box flex={1} mr={1}>
          <Typography fontFamily='Poppins'>Item*</Typography>
          <TextField
            fullWidth
            size='medium'
            variant='outlined'
            placeholder='Enter name of the item'
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
              },
              mt: '5px',
              width: '400px',
            }}
            value={data?.item}
            onChange={(e) =>
              setData({
                ...data,
                item: e.target.value,
              })
            }
          />
          <br />
          <br />
        </Box>

        <Box flex={1} mr={1} pt={2}>
          <Typography fontFamily='Poppins'>Role(s)*</Typography>
          <CheckboxGroup
            selectedValues={data?.role || []}
            onChange={handleType}
          />

          <br />
          <br />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => {
            setOpenModal(false);
          }}
          color='secondary'
        >
          Done
        </Button>
        <Button
          sx={{ textTransform: 'none' }}
          color='primary'
          onClick={() => {
            handlePost();
            setOpenModal(false);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
